import { REPORT_TYPE } from '../Enums/AGENCY_REPORT_TYPE';

export type ReportType = {
  id: REPORT_TYPE;
  label: string;
  successClass: string;
  title: string;
};

export type FilterOption = {
  label: string;
  value: string;
};

export type FilterableFieldsByReport = {
  [key in REPORT_TYPE]: FilterOption[];
};

export type ReportCriterion =
  | { name: 'filter1'; value: string[] }
  | { name: string; value: string | number | null };

export const sections: ReportType[] = [
  {
    id: REPORT_TYPE.SALES,
    label: 'Sales',
    successClass: 'btn-primary',
    title: 'Sales',
  },
  {
    id: REPORT_TYPE.CONTRACTS,
    label: 'Contracts',
    successClass: 'btn-primary',
    title: 'Contracts',
  },
  {
    id: REPORT_TYPE.RTS,
    label: 'RTS',
    successClass: 'btn-primary',
    title: 'RTS',
  },
  {
    id: REPORT_TYPE.LICENSES,
    label: 'Licenses',
    successClass: 'btn-primary',
    title: 'Licenses',
  },
  {
    id: REPORT_TYPE.AGENTS,
    label: 'Agents',
    successClass: 'btn-primary',
    title: 'Agents',
  },
];

// Filter by options for each agency report type (contracts, sales, etc)
export const FILTERABLE_FIELDS_BY_REPORT: FilterableFieldsByReport = {
  [REPORT_TYPE.SALES]: [
    { label: 'Agency', value: 'sales_by_agency' },
    { label: 'Policy Name', value: 'sales_by_plan_name' },
    { label: 'Policy Company', value: 'sales_by_carrier' },
    { label: 'Policy Status', value: 'sales_by_policy_status' },
    { label: 'Source', value: 'sales_by_source' },
    { label: 'PCP Network', value: 'sales_by_pcp_network' },
    { label: 'PCP Name', value: 'sales_by_pcp' },
  ],
  [REPORT_TYPE.CONTRACTS]: [
    { label: 'Contract Status', value: 'contract_status' },
    { label: 'Contract Company', value: 'contract_company' },
    { label: 'Contract Level', value: 'contract_level' },
    { label: 'All', value: 'contract_all' },
  ],
  [REPORT_TYPE.RTS]: [
    //{ label: 'RTS Status', value: 'rts_status' },
    { label: 'Contract Company', value: 'rts_company' },
    { label: 'All', value: 'rts_all' },
  ],
  [REPORT_TYPE.LICENSES]: [
    { label: 'License State', value: 'license_state' },
    { label: 'License Status', value: 'license_status' },
    { label: 'All', value: 'license_all' },
  ],
  [REPORT_TYPE.AGENTS]: [
    { label: 'Agent Classification', value: 'agent_classification' },
    { label: 'Agent State', value: 'agent_state' },
    { label: 'All', value: 'agent_all' },
  ],
};

// Each report type table headers
export const REPORT_HEADERS: Record<REPORT_TYPE, FilterOption[]> = {
  [REPORT_TYPE.SALES]: [
    { label: 'Agent First', value: 'userFirstname' },
    { label: 'Agent Last', value: 'userLastname' },
    { label: 'Status', value: 'indStatus' },
    { label: 'Source', value: 'indSource' },
    { label: 'Lead Status', value: 'leadStatus' },
    { label: 'Lead Date', value: 'leadDate' },
    { label: 'Member First', value: 'indFirstname' },
    { label: 'Member Last', value: 'indLastname' },
    { label: 'Provider First', value: 'indProviderFirstname' },
    { label: 'Provider Last', value: 'indProviderLastname' },
    { label: 'Provider Networks', value: 'indProviderNetworks' },
    { label: 'Policy Type', value: 'policyType' },
    { label: 'Policy Status', value: 'policyStatus' },
    { label: 'Policy Company', value: 'companyName' },
    { label: 'Policy Plan Name', value: 'planName' },
    { label: 'Policy Number', value: 'policyNumber' },
    { label: 'Policy Effective Date', value: 'policyEffective' },
    { label: 'Policy Application Date', value: 'policyAppDate' },
    { label: 'MBI', value: 'indMbiNumber' },
    { label: 'Medicaid ID', value: 'indMedicaidId' },
    { label: 'Member Pref Language', value: 'prefLang' },
  ],
  [REPORT_TYPE.CONTRACTS]: [
    { label: 'Agent First', value: 'userFirstname' },
    { label: 'Agent Last', value: 'userLastname' },
    { label: 'Agent Email', value: 'userUsername' },
    { label: 'Company', value: 'companyName' },
    { label: 'Products', value: 'products' },
    { label: 'States', value: 'states' },
    { label: 'Status', value: 'contractStatus' },
    { label: 'Upline', value: 'contractUpline' },
    { label: 'Contract Level', value: 'contractLevel' },
    { label: 'Contract Date', value: 'contractDate' },
    { label: 'Writing Number', value: 'writingNumber' },
  ],
  [REPORT_TYPE.RTS]: [
    { label: 'Agent First', value: 'userFirstname' },
    { label: 'Agent Last', value: 'userLastname' },
    { label: 'Agent Email', value: 'userUsername' },
    { label: 'Company', value: 'companyName' },
    { label: 'Products', value: 'products' },
    { label: 'States', value: 'states' },
    { label: 'Status', value: 'contractStatus' },
    { label: 'Upline', value: 'contractUpline' },
    { label: 'Contract Level', value: 'contractLevel' },
    { label: 'Contract Date', value: 'contractDate' },
    { label: 'Writing Number', value: 'writingNumber' },
    { label: 'RTS', value: 'rts' },
  ],
  [REPORT_TYPE.LICENSES]: [
    { label: 'Agent First', value: 'userFirstname' },
    { label: 'Agent Last', value: 'userLastname' },
    { label: 'Agent Email', value: 'userUsername' },
    { label: 'State', value: 'licenseState' },
    { label: 'Status', value: 'licenseStatus' },
    { label: 'Expiry', value: 'licenseExpiry' },
    { label: 'Number', value: 'licenseNumber' },
    { label: 'Type', value: 'licenseType' },
  ],
  [REPORT_TYPE.AGENTS]: [
    { label: 'NPN', value: 'npn' },
    { label: 'Classification', value: 'agent_classification' },
    { label: 'Agent First', value: 'userFirstname' },
    { label: 'Agent Last', value: 'userLastname' },
    { label: 'Company Name', value: 'userCompanyName' },
    { label: 'Phone', value: 'userPhone' },
    { label: 'Phone 2', value: 'userPhoneCell' },
    { label: 'Email', value: 'userUsername' },
    { label: 'Email 2', value: 'userEmailAlt' },
    { label: 'Fax', value: 'userFax' },
    { label: 'Street', value: 'userAddressStreet' },
    { label: 'City', value: 'userAddressCity' },
    { label: 'State', value: 'userAddressState' },
    { label: 'Zip', value: 'userAddressZip' },
    { label: 'County', value: 'userAddressCounty' },
    { label: 'DOB', value: 'userDob' },
    { label: 'Account Start', value: 'userTrialStart' },
    { label: 'SSN', value: 'userSsn' },
  ],
};
